import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['input']
  static values = {
    value: { type: String, default: 'true' }
  }

  setValue () {
    this.inputTargets.forEach(input => {
      input.value = this.valueValue
    })
  }
}
